/**
 * @name Birthdays
 * @description Componente de próximos cumpleaños
 * @author César Rivera
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import moment from 'moment';
import styled from 'styled-components';

import { EmployeeDetail } from '@components';
import { Card, MUI, Unicons, Typography } from '@styles';

const Birthdays = (props) => {
  const { birthdays, onOpen } = props;

  const month = new Date().getMonth();
  const today = new Date();
  const tomorrow = moment().add(1, 'd').format('DD/MM');

  const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
    'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
  ];

  // Próximos cumpleaños
  const birthdaysFilter = (a, b) => {
    let x = String(moment(a).format('DD/MM/YYYY'));
    let y = String(moment(b).format('DD/MM/YYYY'));
    return parseInt(x.substring(0, 2)) >= parseInt(y.substring(0, 2)) || parseInt(x.substring(3, 5)) > parseInt(y.substring(3, 5));
  };

  const nextBirthdays = birthdays.filter((item) => birthdaysFilter(item.FechaNacimiento, today));

  return (
    <>
      {/* HEADER */}
      <Card.Header divider>
        <Card.HeaderTitle>
          <Typography.H5>{i18n.t('Home.birthdays')}</Typography.H5>
          <Typography.Text color="greyDarkAlpha">
            {`${i18n.t('GenericMessages.month')}: `}
            <Typography.Span>{i18n.t(`Months.${[monthNames[month]]}`)}</Typography.Span>
          </Typography.Text>
        </Card.HeaderTitle>
        {birthdays.length !== 0 && (
          <Card.HeaderAction>
            <MUI.Tooltip title={i18n.t('GenericMessages.seeAll')}>
              <MUI.ButtonIcon onClick={onOpen}>
                <Unicons.EllipsisH size="20" />
              </MUI.ButtonIcon>
            </MUI.Tooltip>
          </Card.HeaderAction>
        )}
      </Card.Header>
      {/* CONTENT */}
      <Card.Content scroll>
        {nextBirthdays.length !== 0 ? (
          nextBirthdays.map((item, index) => {
            let bdayDate = moment(item.FechaNacimiento).format('DD/MM');
            if (bdayDate === moment(today).format('DD/MM')) {
              bdayDate = i18n.t('Home.today');
            } else if (bdayDate === tomorrow) {
              bdayDate = i18n.t('Home.tomorrow');
            } else {
              bdayDate = moment(item.FechaNacimiento).format(i18n.t('FormatDates.birthday'));
            }

            return (
              <BoxRow key={index}>
                <BirthdayEmployee>
                  <EmployeeDetail
                    avatar={item.Foto}
                    avatarSize={45}
                    employeeName={<Typography.Medium>{item.Nombres}</Typography.Medium>}
                    employeeDetail={<Typography.Text>{item.Area}</Typography.Text>}
                    employeeSubDetail={<Typography.Text color="greyDarkAlpha">{item.Sucursal}</Typography.Text>}

                  />
                </BirthdayEmployee>
                <BirthdayDay>
                  <Typography.Text>{bdayDate}</Typography.Text>
                </BirthdayDay>
              </BoxRow>
            );
          })
        ) : (
          <BoxNotFound>
            <Unicons.CircleExclamation size="20" style={{ marginRight: '12px' }} />
            <Typography.H6>{`${i18n.t('Home.noBirthdaysFound')} ${i18n.t(`Months.${[monthNames[month]]}`)}`}</Typography.H6>
          </BoxNotFound>
        )}
      </Card.Content>
    </>
  );
};

Birthdays.propTypes = {
  // Array con la información de los cumpleaños del mes.
  birthdays: PropTypes.array.isRequired,
  // Función que se ejecuta para abrir el modal.
  onOpen: PropTypes.func.isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const BoxRow = styled.div`
  display: flex;
  padding: 8px;
`;

const BoxNotFound = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;

  .MuiSvgIcon-root {
    margin-right: 12px;
    font-size: 20px;
  }
`;

const BirthdayEmployee = styled.div`
  width: 80%;
`;

const BirthdayDay = styled.div`
  width: 20%;
  align-self: center;
  text-align: end;
  padding: 8px;

  & > p {
    color: ${(props) => props.theme.colors.blueMedium};
  }
`;

export default Birthdays;